export default {
  //default labels
  defConfig: {
    "es-es": {
      processSuccMessage: "Ejecutado correctamente!",
      processSuccdelMessage: "Eliminado correctamente!",
      currency: "Bs.",
      joinwaitlist: "Unirse a la lista de Espera",
      mob_joinwaitlist: "lista de Espera",
      homelabel: "Inicio",
      company: "Compañia",
      massiveloadtitle: "Carga masiva",
      loadid:"Id Carga",
      uploadfilelabel: "Subir archivo",
      uploadingfilelabel:"Subiendo",
      statusloadtitle: "Estado de la carga masiva",
      contact: "Contacto",
      welcomeh1: "Bienvenido",
      welcomeTo: "Bienvenido a ",
      signup: "Registrarse",
      signupmessage: "Sign up to create an account and explore many things",
      agreeTermsRegister: "I agree to the Privacy Policy and Terms of Use",
      signin: "Ingresar",
      signin2: "Ingresar",
      fieldinfo: "Información del campo",
      aditionalcommentary: process.env.REACT_APP_HIDE_ADDCOMMENTARY
        ? "Observaciones"
        : "Comentarios",
      or: "O",
      formfullname: "Nombres",
      commenthistory: process.env.REACT_APP_HIDE_ADDCOMMENTARY
      ? "Observaciones anteriores"
      : "Comentarios anteriores",
      formphonenumber: "Número de Telefono",
      formemail: "Correo electr\u00F3nico",
      acceptlabel: "Aceptar",
      // Tarea sin transicion de salida en el diseno del flujo: el unico boton
      // posible guarda el comentario, NO ejecuta ni avanza el flujo. Antes esto
      // se rotulaba "Aceptar" y el usuario creaba que la tarea avanzaba.
      savecommentonlylabel: "Guardar comentario",
      closetasknooptionlabel: "Cerrar tarea (sin salida)",
      nooptionhintlabel:
        "Esta tarea no tiene una salida configurada: el botón solo guarda el comentario. El flujo avanza solo (por temporizador o proceso automático).",
      formlogingoogle: "Ingrese con Google",
      formloginfacebook: "Ingrese con Facebook",
      formpassword: "Contraseña",
      formpassword2: "Repita el contraseña",
      responselabel:"Respuesta",
      gootologin: "Tienes una cuenta?",
      forgotpassword: "Olvidó su contraseña?",
      recoverypassword: "Enviar link de recuperación",
      createAccount: "Empezar el trial",
      confirmlogout: "Confirma que desea salir?",
      myaccountlabel: "Mi cuenta",
      logoutlabel: "Salir",
      showloadslabel: "Mostrar estado de carga masiva",
      statuslabel: "Estado",
      closelabel: "Cerrar",
      createlabel: "Crear nuevo registro",
      filterlabel: "Filtros",
      actionslabel: "Acciones",
      deleteItemlabel: "Eliminar Registro",
      deletelabel: "Eliminar",
      cancellabel: "Cancelar",
      backlabel: "Atras",
      previewlabel: "Vista Previa",
      refreshlabel: "Refrescar",
      refreshtablelabel: "Refrescar Tabla",
      totaltaskslabel: "Total tareas",
      filterlabelsmessage: "Filtro por etiqueta",
      novaluesmessage: "No hay datos",
      deteledisclaimer: "Esta seguro de eliminar este registro?",
      notloggedmessage1: "Want to know more about your property?",
      notloggedmessage2: "Sign-up today to learn more.",
      savedatalabel: "Guardar Datos",
      chooseimagelabel: "Elegir Imagen",
      changeimagelabel: "Cambiar Imagen",
      createfieldslabel: "Crear Campos",
      editfieldslabel: "Administrar Campos",
      createlistlabel: "Crear Lista",
      editlistlabel: "Editar Lista",
      createitemslabel: "Crear Elementos",
      edititemslabel: "Editar Elementos",
      addfieldlabel: "Agregar Campo",
      addcolumnlabel: "Agregar Columna",
      savelabel: "Guardar",
      updatelabel: "Editar registro",
      fieldnamelabel: "Nombre del Campo",
      fieldlabellabel: "Etiqueta del Campo",
      fieldtypelabel: "Tipo de Campo",
      colsizemobilelabel: "Tama\u00F1o Mobile",
      colsizeweblabel: "Tama\u00F1o Web",
      stylelabel: "Estilo",
      validationsabel: "Validaciones",
      fontsizelabel: "Tama\u00F1o del Texto",
      fontcolorlabel: "Color",
      alertmessagelabel: "Mensaje de Alerta",
      fieldrequiredlabel: "Campo Requerido",
      fieldlabel: "Campo",
      justtextlabel: "Solo Texto",
      justnumberlabel: "Solo N\u00FAmero",
      justemaillabel: "Solo email",
      minvaluelabel: "Valor m\u00EDnimo",
      maxvaluelabel: "Valor m\u00E1ximo",
      staticdatalabel: "Datos Estaticos",
      dynamiclabel: "Datos din\u00E1micos",
      maxsizemobilemessage:
        "En la versi\u00F3 movil solo se podra dividir hasta en 2 por fila",
      multimediamanagerlabel: "Gestor Multimedia",
      pathlabel: "Ruta",
      searchinputlabel: "Buscar Archivo",
      searchlabel: "Buscar",
      viewlogstitle: "Ver logs del registro seleccionado",
      previouslabel: "Anterior",
      nextlabel: "Siguiente",
      testscriptlabel: "Probar Script",
      loadformlabel: "Carga Formulario",
      refreshingformlabel: "Refrescando",
      optionslabel: "Opciones",
      urlapilabel: "url de la API",
      methodlabel: "Metodo",
      datatosendlabel: "Datos a enviar",
      tokenlabel: "Token",
      labellabel: "Etiqueta",
      valuelabel: "Valor",
      fieldactionlabel: "Accion",
      confirmlabel: "Confirmar",
      oldpasswordlabel: "Contraseña actual",
      newpasswordlabel: "Nueva Contraseña",
      repeatpasswordlabel: "Repita la Contraseña",
      contact: "Contacto",
      support: "Soporte",
      taken: "Asignadas",
      openexternal: "Abrir en nueva ventana",
      memoryheader: "Memoria (ID Flujo:",
      memorylabel: "Memoria",
      nomemorymessage: "Sin datos de memoria para esta tarea",
      taskformtitle:
        "Formulario de la " +
        (process.env.REACT_APP_CUSTOM_TASKLABEL || "Tarea"),
      nopendings:
        "Sin " +
        (process.env.REACT_APP_CUSTOM_TASKSLABEL || "Tareas") +
        " pendientes",
      take: "Asignar " /* + (process.env.REACT_APP_CUSTOM_TASKLABEL || "Tarea")*/,
      grouptasks: "Agrupar",
      expired: "Expiradas",
      errorTasksLabel: "Errores",
      errorTasksTitle: "Tareas con error",
      noErrorTasks: "Sin tareas en error",
      viewInSearcher: "Ver en buscador",
      andMoreErrors: "y más…",
      instanceIdLabel: "ID Instancia",
      instanceIdPH: "Ej: 263",
      refreshingtasks: "Actualizando",
      ccomponents: "Componentes",
      changepassword: "Cambiar contraseña",
      messagePasswordVal0: "Las contraseña nueva debe tener al menos 8 dígitos",
      messagePasswordVal1: "Las contraseñas no coinciden",
      messagePasswordVal2: "Las contraseña no se puede repetir",
      changelabel: "Cambiar",
      activeflowslabel:
        (process.env.REACT_APP_CUSTOM_FLOWSLABEL || "Flujos") + " Activos",

      activetaskslabel:
        (process.env.REACT_APP_CUSTOM_TASKSLABEL || "Tareas") + " Activas",
      takentaskslabel:
        (process.env.REACT_APP_CUSTOM_TASKSLABEL || "Tareas") + " Asignadas",
      expiredtaskslabel:
        (process.env.REACT_APP_CUSTOM_TASKSLABEL || "Tareas") + " Expiradas",
      mytaskslabel:
        "Mis " +
        (process.env.REACT_APP_CUSTOM_TASKSLABEL || "Tareas") +
        " pendientes",

      notaskslabel:
        "No hay " +
        (process.env.REACT_APP_CUSTOM_TASKSLABEL || "Tareas") +
        " pendientes en este momento",
      pageslabel: process.env.REACT_APP_CUSTOM_PAGESLABEL || "Páginas",
      developercenterlabel: "Repositorio de Apis",
      myapislabel: "Mis APIs",
      communityapislabel: "APIs públicas",
      administrationlabel: "Administración",
      flowslabel: process.env.REACT_APP_CUSTOM_FLOWSMENULABEL || "Flujos",
      searchflowslabel:
        "Buscar " + (process.env.REACT_APP_CUSTOM_FLOWSLABEL || "Flujos"),
      formorganization: "Organización",
      ORGANIZATION: "Organización",
      organizations: process.env.REACT_APP_CUSTOM_AREASLABEL || "Áreas",
      actors: process.env.REACT_APP_CUSTOM_ACTORSLABEL || "Actores",
      ORGANIZATIONPROCESS: "Procesos de negocio",
      tasks: process.env.REACT_APP_CUSTOM_TASKSLABEL || "Tareas",
      flows: process.env.REACT_APP_CUSTOM_FLOWSLABEL || "Flujos",
      flowgroups: "Grupos",
      COMPONENTS: process.env.REACT_APP_CUSTOM_PAGESLABEL || "Componentes de negocio",
      forms: "Formularios",
      dashboards: "Reportes y Gráficos",
      templates: "Menu Personalizado",
      jobs: "Trabajos agendados",
      pages: "Páginas",
      SYSTEM: "Seguridad",
      users: "Usuarios",
      usergroups: "Roles",
      ENABLED: "Habilitado",
      DISABLED: "Deshabilitado",
      myprofilelabel: "Mi Perfil",
      profileinfotab: "Información",
      activelabel: "Activo",
      inactivelabel: "Inactivo",
      namelabel: "Nombre",
      lastnamelabel: "Apellido",
      usernamelabel: "Usuario",
      emaillabel: "Email",
      changepasswordhint: "Ingresa tu contraseña actual y elige una nueva de al menos 8 caracteres.",
      passwordchangedsuccess: "Contraseña actualizada correctamente.",
      passwordchangedfailed: "Error al cambiar la contraseña.",
      ACTIVITY: "Manual",
      AUTOMATIC: "Automática",
      executetasklabel:
        "Ejecutar " + (process.env.REACT_APP_CUSTOM_TASKLABEL || "Tarea"),
      executelabel: (process.env.REACT_APP_CUSTOM_EXECUTETASK ||"Ejecutar"),
      executetaskslabel:
        "Ejecutar " + (process.env.REACT_APP_CUSTOM_TASKSLABEL || "Tareas"),
      editlabel: "Editar Registro",
      addcomment: "Comentar",
      comment: process.env.REACT_APP_HIDE_ADDCOMMENTARY
        ? "Observaciones"
        : "Comentar",
      view: "Ver",
      manageorgchartlabel: "Organigrama",
      managevariableslabel: "Variables",
      managediagramlabel: "Diagrama",
      flowstudiolabel: "Editor de flujos (beta)",
      defineversionslabel: "Definir Version",
      startdatelabel: "Fecha Inicio",
      setHeaderColumns :"Seleccionar columnas",
      setHeaderColumnsText :"Seleccione las columndas q desea ver en el reporte", 

      initflowlabel: "Iniciar flujo",
      addactorslabel:
        "Agregar" + (process.env.REACT_APP_CUSTOM_ACTORSLABEL || "Actores"),
      adduserslabel: "Agregar usuarios",
      importlabel: "Importar",
      templateslabel: "Menu Personalizado",
      deselectall: "Quitar todo",
      selectall: "Sel. Todo",
      notaskselected:
        "Ninguna " +
        (process.env.REACT_APP_CUSTOM_TASKLABEL || "Tarea") +
        " seleccionada",
      ungrouplabel: "Desaagrupar",
      assigned: "asignadas",
      tasktaken: "asignada",
      takelabel: "tomar",
      unassigned: "sin asignar",
      all: "todas",
      release: "Liberar",
      "ALL FLOWS":
        "Todos los " + (process.env.REACT_APP_CUSTOM_FLOWSLABEL || "Flujos"),
      tasksuspendedlabel: "Tarea suspendida",
      tasksuspenderrorlabel: "No se pudo suspender",
      taskresumedlabel: "Tarea reanudada",
      taskresumeerrorlabel: "No se pudo reanudar",
      taskreassignedlabel: "Tarea reasignada",
      taskreassignerrorlabel: "No se pudo reasignar",
      selecttargetuserlabel: "Selecciona un usuario destino",
      confirmsuspendtasklabel: "¿Suspender esta tarea? Saldrá de pendientes hasta que se reanude.",
      nosearchresultslabel: "Sin resultados para la búsqueda.",
      norecordslabel: "No hay registros.",
      loadingdatalabel: "Cargando datos...",
      loadconfigerrormessage: "No se pudo cargar la configuración de esta vista.",
      swfTitle: "Búsqueda de flujos",
      swfResultsTitle: "Instancias de flujo",
      swfDatePeriod: "Período",
      swfProcessLabel: "Flujo *",
      swfStatusLabel: "Estado",
      swfOfficeLabel: "Oficina / Código",
      swfSearchBtn: "Buscar",
      swfSelectProcess: "— Seleccionar flujo —",
      swfAllStatuses: "Todos los estados",
      swfInProgress: "En progreso",
      swfCompleted: "Completado",
      swfError: "Error",
      swfToday: "Hoy",
      swfOfficePlaceholder: "Buscar oficina…",
      swfCustomRange: "Rango personalizado…",
      swfAvgDuration: "Dur. promedio",
      swfNoInstances: "No se encontraron instancias",
      swfNoInstancesHint: "Intenta ampliar el rango de fechas o quitar filtros",
      swfResponseDetail: "Detalle de respuesta",
      swfViewResponse: "Ver respuesta",
      swfHideResponse: "Ocultar respuesta",
      swfResponse: "Respuesta",
      swfReactivateTask: "Reactivar tarea",
      swfTaskReactivated: "Tarea reactivada",
      swfTaskReactivateError: "No se pudo reactivar la tarea",
      swfKillTask: "Desactivar tarea",
      swfTaskKilled: "Tarea desactivada",
      swfTaskKillError: "No se pudo desactivar la tarea",
      swfTaskStatus: "Estado",
      swfTaskAttempts: "Intentos",
      swfTaskStatusPending: "Pendiente",
      swfTaskStatusCompleted: "Completada",
      swfTaskStatusError: "Error",
      swfTaskStatusAuto: "Automática",
      swfTaskStatusFinished: "Finalizada",
      swfTaskStatusRunning: "En ejecución",
      swfTaskStatusSuspended: "Suspendida",
      swfSelectRowForDetails: "Selecciona una fila para ver sus datos",
      swfSelectRowForDiagram: "Selecciona una fila para ver el diagrama",
      swfRefresh: "Actualizar",
      swfViewData: "Ver datos",
      swfDiagram: "Diagrama",
      swfNoVars: "Sin variables adicionales registradas.",
      swfNoTasks: "Sin tareas registradas.",
      swfDataSection: "Datos del flujo",
      swfTaskHistory: "Historial de tareas",
      swfSummaryStart: "Inicio",
      swfSummaryEnd: "Fin",
      swfSummaryDuration: "Duración",
      swfSummaryOffice: "Oficina",
      swfSummaryVersion: "Versión",
      swfSelectProcessReq: "Selecciona un flujo",
      swfDaysUnit: "días",
      swfPageLabel: "Página",
      swfMultiFlowHint: "Ctrl+Clic para elegir varios flujos",
      swfMultiFlowCount: "seleccionados",
      swfMultiFlowPrimaryHint: "El primer flujo define las columnas y el filtro de variables",
      swfInstanceIdLabel: "ID Instancia",
      swfInstanceIdPH: "Ej: 263",
      swfVarFilterLabel: "Variable",
      swfVarFilterAny: "— Variable —",
      swfVarFilterValuePH: "Valor contiene...",
      swfShowAllTasks: "Ver todas las tareas",
      swfColInstanceId: "Instancia",
      swfColFlow: "Flujo",
      swfColVersion: "Ver.",
      swfColStarted: "Iniciado",
      swfColEnded: "Finalizado",
      swfColTask: "Tarea",
      swfColUser: "Usuario",
      swfColActor: "Actor",
      swfHasErrorHint: "Esta instancia tiene una tarea en error — click para expandir",
      mcnComponentType: "Tipo de componente",
      mcnGeneralInfo: "Información general",
      mcnConfiguration: "Configuración",
      mcnBody: "Cuerpo",
      mcnPaymentType: "Tipo de pago",
      mcnFinish: "Finalizar",
      mcnStep: "Paso",
      mcnTestApi: "Probar API",
      mcnCancel: "Cancelar",
      mcnConfigureFields: "Configurar campos",
      mcnDeveloperConnectors: "APIs Personalizadas",
      mcnTestBeforePublish: "Puedes probar tu conector antes de publicarlo",
      mcnTestYourApi: "Probar tu API",
      mcnBack: "Atrás",
      mcnNext: "Siguiente",
      mcnCreateConnector: "Crear mi conector",
      mcnUpdateConnector: "Actualizar mi conector",
      mcnBodyLabel: "Cuerpo",
      mcnPostExecutionScript: "Script de post-ejecución",
      mcnNotImplemented: "No implementado",
      mcnChooseType: "Elige el tipo de tu conector:",
      mcnPrivate: "PRIVADO",
      mcnPrivateDesc: "Solo tu organización puede usar este conector",
      mcnPublic: "PÚBLICO",
      mcnPublicDesc: "Cualquiera puede usar este conector y puedes ganar dinero por su uso",
      mcnFinishedTitle: "¡Configuración de la API finalizada!",
      mcnFinishedSubtitle: "Tu conector se guardó correctamente.",
      mcnReturnToConnectors: "Volver a mis conectores",
      mcnInputs: "Inputs",
      mcnAdd: "Añadir",
      mcnNoInputsDefined: "Sin inputs definidos — usá \"Añadir\" para agregar parámetros al conector",
      mcnNoName: "(sin nombre)",
      mcnNoLabel: "sin etiqueta",
      mcnMoveUp: "Subir",
      mcnMoveDown: "Bajar",
      mcnInputName: "Nombre del input",
      mcnInputLabel: "Etiqueta del input",
      mcnType: "Tipo",
      mcnRequired: "Requerido",
      mcnDeleteInput: "Eliminar input",
      mcnValidateSyntaxTitle: "Validar sintaxis de JavaScript",
      mcnValidateSyntax: "Validar sintaxis",
      mcnSyntaxOk: "Sintaxis correcta — no se encontraron errores.",
    },

    "en-us": {
      processSuccMessage: "Process executed Succesfully!",
      processSuccdelMessage: "Successfully deleted!",
      currency: "$",
      joinwaitlist: "Join Waitlist",
      mob_joinwaitlist: "Join Waitlist",
      homelabel: "Home",
      company: "Company",
      massiveloadtitle: "Massive load",
      loadid:"Laod Id",
      uploadfilelabel: "Upload File",
      uploadingfilelabel:"Uploading",

      statusloadtitle: "Massive load status",
      contact: "Contact",
      welcomeh1: "Welcome",
      welcomeTo: "Welcome to ",
      signup: "Sign Up",
      signupmessage: "Sign up to create an account and explore many things",
      agreeTermsRegister: "I agree to the Privacy Policy and Terms of Use",
      signin: "Sign in",
      signin2: "Sign in",
      fieldinfo: "Field Info",
      aditionalcommentary: "Aditional Commentary",
      or: "OR",
      formfullname: "Full Name",
      commenthistory: "Comment history",
      formphonenumber: "Phone Number",
      formemail: "Email Address",
      acceptlabel: "Accept",
      savecommentonlylabel: "Save comment",
      closetasknooptionlabel: "Close task (no exit)",
      nooptionhintlabel:
        "This task has no configured exit: the button only saves the comment. The flow moves on by itself (timer or automatic step).",
      formlogingoogle: "Sign up with Google",
      formloginfacebook: "Sign up with Facebook",
      formpassword: "Password",
      formpassword2: "Re-type password",
      responselabel:"Response",
      gootologin: "Do you already have an account?",
      forgotpassword: "Forgot password?",
      recoverypassword: "Send recovery link",
      createAccount: "Start free trial",
      confirmlogout: "Confirm to logout?",
      myaccountlabel: "My Account",
      logoutlabel: "Logout",
      showloadslabel: "show massive load status",
      statuslabel: "Status",
      closelabel: "Close",
      createlabel: "Create new item",
      filterlabel: "Filters",
      actionslabel: "Actions",
      deleteItemlabel: "Delete Item",
      deletelabel: "Delete",
      cancellabel: "Cancel",
      backlabel: "Back",
      previewlabel: "Preview",
      refreshlabel: "Refresh",
      refreshtablelabel: "Refrescar Table",
      totaltaskslabel: "Total Tasks",
      filterlabelsmessage: "Filter labels",
      novaluesmessage: "No labels",
      deteledisclaimer: "Are you sure to delete this item",
      notloggedmessage1: "Want to know more about your property?",
      notloggedmessage2: "Signup today to learn more.",
      savedatalabel: "Save Data",
      chooseimagelabel: "Choose Image",
      changeimagelabel: "Change Image",
      createfieldslabel: "Create Fields",
      editfieldslabel: "Manage Fields",
      createlistlabel: "Create List",
      editlistlabel: "Update List",
      createitemslabel: "Create Items",
      edititemslabel: "Update Items",
      addfieldlabel: "Add Field",
      addcolumnlabel: "Add Column",
      savelabel: "Save",
      updatelabel: "Update item",
      fieldnamelabel: "Field Name",
      fieldlabellabel: "Label Name",
      fieldtypelabel: "Field Type",
      colsizemobilelabel: "Mobile Size",
      colsizeweblabel: "Web Size",
      stylelabel: "Style",
      validationsabel: "Validations",
      fontsizelabel: "Font Size",
      fontcolorlabel: "Color",
      alertmessagelabel: "Alert Message",
      fieldrequiredlabel: "Field Required",
      fieldlabel: "Field",
      justtextlabel: "Just Text",
      justnumberlabel: "Just Number",
      justemaillabel: "Just email",
      minvaluelabel: "Min value",
      maxvaluelabel: "Max value",
      staticdatalabel: "Static Data",
      dynamiclabel: "Dynamic Data",
      maxsizemobilemessage:
        "Mobile Version only accepts max 2 fields per Column",
      multimediamanagerlabel: "Multimedia Manager",
      pathlabel: "Path",
      searchinputlabel: "Search File",
      searchlabel: "Search",
      viewlogstitle: "View logs for selected item",
      previouslabel: "Previous",
      nextlabel: "Next",
      testscriptlabel: "Test Script",
      loadformlabel: "Load Form",
      refreshingformlabel: "Refresing...",
      optionslabel: "Options",
      urlapilabel: "API url",
      methodlabel: "Method",
      datatosendlabel: "Data to send",
      tokenlabel: "Token",
      labellabel: "Label",
      valuelabel: "value",
      fieldactionlabel: "Action",
      confirmlabel: "Confirm",
      oldpasswordlabel: "Old Password",
      newpasswordlabel: "New Password",
      repeatpasswordlabel: "Confirm Password",
      contact: "Contact",
      support: "Support",
      taken: "Taken",
      openexternal: "Open in new window",
      memoryheader: "Memory (Flow id:",
      memorylabel: "Memory",
      nomemorymessage: "No data in memory for this task",
      taskformtitle: "Task Form",
      nopendings: "No pending tasks to display",
      take: "Take task",
      grouptasks: "Group Tasks",
      expired: "Expired",
      errorTasksLabel: "Errors",
      errorTasksTitle: "Tasks with error",
      noErrorTasks: "No tasks in error",
      viewInSearcher: "View in searcher",
      andMoreErrors: "and more…",
      instanceIdLabel: "Instance ID",
      instanceIdPH: "E.g: 263",
      refreshingtasks: "Updating Tasks...",
      ccomponents: "Custom Components",
      changepassword: "Change Password",
      messageP1: "The password and confirmation password do not match",
      changelabel: "Change",
      activeflowslabel: "Active Flows",
      activetaskslabel: "Active tasks",
      takentaskslabel: "Assigned Tasks",
      expiredtaskslabel: "Expired Tasks",
      mytaskslabel: "My tasks",
      notaskslabel: "There are no tasks at the moment",
      pageslabel: process.env.REACT_APP_CUSTOM_PAGESLABEL || "Pages",
      developercenterlabel: "APIs Center",
      myapislabel: "My APIs",
      communityapislabel: "Community APIs",
      administrationlabel: "Administration",
      flowslabel: "Flows",
      searchflowslabel: "Search Flows",
      tasktaken: "taken",
      takelabel: "take",
      formorganization: "Organization",
      ORGANIZATION: "My Organization",
      organizations: "Organizational Chart",
      actors: "Actors",
      ORGANIZATIONPROCESS: "Organization Process",
      tasks: "Tasks",
      flows: "Flows",
      flowgroups: "Flow Groups",
      COMPONENTS: "Business Components",
      forms: "Forms",
      dashboards: "Dashboards & Dashboards",
      templates: "Templates",
      jobs: "Jobs",
      pages: "Pages",
      SYSTEM: "Security",
      users: "Users",
      usergroups: "User Groups",
      ENABLED: "Enabled",
      DISABLED: "Disabled",
      ACTIVITY: "Manual",
      AUTOMATIC: "Automatic",
      myprofilelabel: "My Profile",
      profileinfotab: "Information",
      activelabel: "Active",
      inactivelabel: "Inactive",
      namelabel: "First Name",
      lastnamelabel: "Last Name",
      usernamelabel: "Username",
      emaillabel: "Email",
      changepasswordhint: "Enter your current password and choose a new one with at least 8 characters.",
      passwordchangedsuccess: "Password updated successfully.",
      passwordchangedfailed: "Error changing password.",
      executetasklabel: "Execute task",
      executelabel: "Execute",
      executetaskslabel: "Execute tasks",
      editlabel: "Edit item",
      addcomment: "Add Comment",
      comment: "Comment",
      view: "View",
      manageorgchartlabel: "Organigram Chart",
      managevariableslabel: "Variables",
      managediagramlabel: "Diagram",
      flowstudiolabel: "Flow Studio (beta)",
      defineversionslabel: "Define Version",
      startdatelabel: "Start Date",
      setHeaderColumns :"Set header columns", 
      setHeaderColumnsText :"Select cols to report", 

      initflowlabel: "Init Flow",
      addactorslabel: "Add Actors",
      adduserslabel: "Add Users",
      importlabel: "Importar",
      templateslabel: "Templates",
      deselectall: "Unselect All",
      selectall: "Select All",
      notaskselected: "No tasks selected",
      ungrouplabel: "Ungroup",
      assigned: "assigned",
      unassigned: "unassigned",
      all: "all",
      release: "Release",
      tasksuspendedlabel: "Task suspended",
      tasksuspenderrorlabel: "Could not suspend task",
      taskresumedlabel: "Task resumed",
      taskresumeerrorlabel: "Could not resume task",
      taskreassignedlabel: "Task reassigned",
      taskreassignerrorlabel: "Could not reassign task",
      selecttargetuserlabel: "Select a target user",
      confirmsuspendtasklabel: "Suspend this task? It will leave your pending tasks until resumed.",
      nosearchresultslabel: "No results for your search.",
      norecordslabel: "No records found.",
      loadingdatalabel: "Loading data...",
      loadconfigerrormessage: "Could not load the configuration for this view.",
      swfTitle: "Flow Instance Search",
      swfResultsTitle: "Flow Instances",
      swfDatePeriod: "Date period",
      swfProcessLabel: "Flow *",
      swfStatusLabel: "Status",
      swfOfficeLabel: "Office / Code",
      swfSearchBtn: "Search",
      swfSelectProcess: "— Select flow —",
      swfAllStatuses: "All statuses",
      swfInProgress: "In Progress",
      swfCompleted: "Completed",
      swfError: "Error",
      swfToday: "Today",
      swfOfficePlaceholder: "Search office…",
      swfCustomRange: "Custom range…",
      swfAvgDuration: "Avg. duration",
      swfNoInstances: "No instances found",
      swfNoInstancesHint: "Try expanding the date range or removing filters",
      swfResponseDetail: "Response detail",
      swfViewResponse: "View response",
      swfHideResponse: "Hide response",
      swfResponse: "Response",
      swfReactivateTask: "Reactivate task",
      swfTaskReactivated: "Task reactivated",
      swfTaskReactivateError: "Could not reactivate task",
      swfKillTask: "Deactivate task",
      swfTaskKilled: "Task deactivated",
      swfTaskKillError: "Could not deactivate task",
      swfTaskStatus: "Status",
      swfTaskAttempts: "Attempts",
      swfTaskStatusPending: "Pending",
      swfTaskStatusCompleted: "Completed",
      swfTaskStatusError: "Error",
      swfTaskStatusAuto: "Automatic",
      swfTaskStatusFinished: "Finished",
      swfTaskStatusRunning: "Running",
      swfTaskStatusSuspended: "Suspended",
      swfSelectRowForDetails: "Select a row to view details",
      swfSelectRowForDiagram: "Select one row to view diagram",
      swfRefresh: "Refresh",
      swfViewData: "View data",
      swfDiagram: "Diagram",
      swfNoVars: "No additional variables recorded.",
      swfNoTasks: "No tasks recorded.",
      swfDataSection: "Flow data",
      swfTaskHistory: "Task history",
      swfSummaryStart: "Start",
      swfSummaryEnd: "End",
      swfSummaryDuration: "Duration",
      swfSummaryOffice: "Office",
      swfSummaryVersion: "Version",
      swfSelectProcessReq: "Select a flow",
      swfDaysUnit: "days",
      swfPageLabel: "Page",
      swfMultiFlowHint: "Ctrl+Click to pick several flows",
      swfMultiFlowCount: "selected",
      swfMultiFlowPrimaryHint: "The first flow defines the columns and the variable filter",
      swfInstanceIdLabel: "Instance ID",
      swfInstanceIdPH: "e.g. 263",
      swfVarFilterLabel: "Variable",
      swfVarFilterAny: "— Variable —",
      swfVarFilterValuePH: "Value contains...",
      swfShowAllTasks: "Show all tasks",
      swfColInstanceId: "Instance",
      swfColFlow: "Flow",
      swfColVersion: "Ver.",
      swfColStarted: "Started",
      swfColEnded: "Ended",
      swfColTask: "Task",
      swfColUser: "User",
      swfColActor: "Actor",
      swfHasErrorHint: "This instance has a task in error — click to expand",
      mcnComponentType: "Component Type",
      mcnGeneralInfo: "General info",
      mcnConfiguration: "Configuration",
      mcnBody: "Body",
      mcnPaymentType: "Payment Type",
      mcnFinish: "Finish",
      mcnStep: "Step",
      mcnTestApi: "Test Api",
      mcnCancel: "Cancel",
      mcnConfigureFields: "Configure Fields",
      mcnDeveloperConnectors: "Custom APIs",
      mcnTestBeforePublish: "You can test your connector before publish",
      mcnTestYourApi: "Test your Api",
      mcnBack: "Back",
      mcnNext: "Next",
      mcnCreateConnector: "Create my connector",
      mcnUpdateConnector: "Update my connector",
      mcnBodyLabel: "body",
      mcnPostExecutionScript: "Post execution Script",
      mcnNotImplemented: "not implemented",
      mcnChooseType: "Choose your connector type:",
      mcnPrivate: "PRIVATE",
      mcnPrivateDesc: "Just your organization can use this connector",
      mcnPublic: "PUBLIC",
      mcnPublicDesc: "Everyone can use this connector and you can Earn money for use",
      mcnFinishedTitle: "API configuration finished!",
      mcnFinishedSubtitle: "Your connector has been Successfully saved.",
      mcnReturnToConnectors: "Return to my connectors",
      mcnInputs: "Inputs",
      mcnAdd: "Add",
      mcnNoInputsDefined: "No inputs defined — use \"Add\" to add parameters to the connector",
      mcnNoName: "(no name)",
      mcnNoLabel: "no label",
      mcnMoveUp: "Move up",
      mcnMoveDown: "Move down",
      mcnInputName: "Input Name",
      mcnInputLabel: "Input Label",
      mcnType: "Type",
      mcnRequired: "Required",
      mcnDeleteInput: "Delete input",
      mcnValidateSyntaxTitle: "Validate JavaScript syntax",
      mcnValidateSyntax: "Validate syntax",
      mcnSyntaxOk: "Syntax OK — no errors found.",
    },
  },
  conpanyInfo: process.env.REACT_APP_COMPANYNAME,
  //reference emal
  RefEmail: "mail@mail.com",

  //home header link items
  MenuLinks: {
    "en-us": [
      { mainLink: "Home", subLink: [], path: "/" } /*
			{ mainLink: "FAQs", subLink: [], path: '/faqs' },
	    { mainLink: "Blog", subLink: [], path: '/blogs' },    */,
    ],
    "es-es": [
      { mainLink: "Inicio", subLink: [], path: "/" } /*
			{ mainLink: "FAQs", subLink: [], path: '/faqs' },
	    { mainLink: "Blog", subLink: [], path: '/blogs' },  */,
    ],
  },

  SideBarLinks: {
    "en-us": [
      { label: "Dashboard", subLink: [], path: "/dashboard" },
      { label: "Project Planner", subLink: [], path: "/project-planer" },
      { label: "Equity", subLink: [], path: "/blogs" },
      { label: "Renovation", subLink: [], path: "/blogs" },
      { label: "Resources", subLink: [], path: "/blogs" },
      { label: "Account Settings", subLink: [], path: "/blogs" },
      { label: "Log-off", subLink: [], path: "/blogs" },
    ],
    "es-es": [
      { label: "Dashboard", subLink: [], path: "/dashboard" },
      { label: "Project Planner", subLink: [], path: "/project-planer" },
      { label: "Equity", subLink: [], path: "/blogs" },
      { label: "Renovation", subLink: [], path: "/blogs" },
      { label: "Resources", subLink: [], path: "/blogs" },
      { label: "Account Settings", subLink: [], path: "/blogs" },
      { label: "Log-off", subLink: [], path: "/blogs" },
    ],
  },

  //home header link items
  footerLinks: {
    "en-us": [
      { mainLink: "Terms Of Service", path: "/home" },
      { mainLink: "Privacy Policy", path: "/faqs" },
    ],
    "es-es": [
      { mainLink: "Terminos y Condiciones", path: "/home" },
      { mainLink: "Politica de Privacidad", path: "/faqs" },
    ],
  },

  //home header steps
  footerSteps: {
    "en-us": [
      '1. The Chloe HELOC is a variable rate product. The annual percentage rate (APR) is based on the Prime Rate plus a margin that doesn\'t change. The Prime Rate is the highest prime rate published in The Wall Street Journal "Money Rates" table (the "Index"). The Index as of 03/21/2022 is 3.50%. Your initial APR is based on your creditworthiness when you open your account. The maximum APR will not exceed 18% during the life of your account.',
      "2. Some transactions may require in-person signatures, including loans secured by properties located in counties that do not permit recording of e-signatures or that otherwise require an in-person closing.",
    ],
    "es-es": [
      '1. The Chloe HELOC is a variable rate product. The annual percentage rate (APR) is based on the Prime Rate plus a margin that doesn\'t change. The Prime Rate is the highest prime rate published in The Wall Street Journal "Money Rates" table (the "Index"). The Index as of 03/21/2022 is 3.50%. Your initial APR is based on your creditworthiness when you open your account. The maximum APR will not exceed 18% during the life of your account.',
      "2. Some transactions may require in-person signatures, including loans secured by properties located in counties that do not permit recording of e-signatures or that otherwise require an in-person closing.",
    ],
  },

  //home - list of services
  Services: {
    "en-us": [
      {
        icon: "./images/img1.PNG",
        title: "Renovate my home",
        button: "Discover More",
        link: "/doc/bdp_lab.pdf",
        description:
          "Metus, diam pretium at at morbi vulputate et. Tellus ipsum sollicitudin ut eu a lectus potenti maecenas ",
      },
      {
        icon: "./images/img2.PNG",
        title: "Consolidate my debt",
        link: "/doc/programa_aceleracion.pdf",
        button: "Start Now",
        description:
          "Metus, diam pretium at at morbi vulputate et. Tellus ipsum sollicitudin ut eu a lectus potenti maecenas ",
      },
      {
        icon: "./images/img3.PNG",
        title: "Valuate my home",
        link: "/doc/asistencia_tecnica.pdf",
        button: "Start Today",
        description:
          "Metus, diam pretium at at morbi vulputate et. Tellus ipsum sollicitudin ut eu a lectus potenti maecenas ",
      },
    ],
    "es-es": [
      {
        icon: "./images/img1.PNG",
        title: "Renovate my home",
        button: "Discover More",
        link: "/doc/bdp_lab.pdf",
        description:
          "Metus, diam pretium at at morbi vulputate et. Tellus ipsum sollicitudin ut eu a lectus potenti maecenas ",
      },
      {
        icon: "./images/img2.PNG",
        title: "Consolidate my debt",
        link: "/doc/programa_aceleracion.pdf",
        button: "Start Now",
        description:
          "Metus, diam pretium at at morbi vulputate et. Tellus ipsum sollicitudin ut eu a lectus potenti maecenas ",
      },
      {
        icon: "./images/img3.PNG",
        title: "Valuate my home",
        link: "/doc/asistencia_tecnica.pdf",
        button: "Start Today",
        description:
          "Metus, diam pretium at at morbi vulputate et. Tellus ipsum sollicitudin ut eu a lectus potenti maecenas ",
      },
    ],
  },
};
